<template>
	<!-- 发票详情 -->
	<div class="wid-100">
		<!--  v-show="$route.meta.showFather" -->
		<div class="" style="" v-show="$route.meta.showFather">
			<div class="box-shadow pad-16 mb-16">
				<div class="flex-1 jus-bet mb-16">
					<div class="flex-1 jus-bet">
						<div class="left-icon"></div>
						<p class="experts">收费明细</p>
					</div>
					<div class="flex-1 jus-bet" @click="relate(details.id)">
						<p class="font-1" style="color: #333333;">关联订单</p>
						<i class="el-icon-arrow-right c-iocn" style="padding-left: 8px;"></i>
					</div>
				</div>
				<div class="flex-1">
					<p class="tiantou font-1">发票总额:</p>
					<p class="money money-1">￥{{details.amount}}</p>
				</div>
			</div>
			<div class="box-shadow mb-16">
				<div :class="details.status==2000 ?'col-1':details.status==1000?'col-3':'col-2'" class="status font-1">
					<span>发票状态:</span>
					{{details.status==1000 ? '开票中' : details.status==2000 ? '已开票' : '已驳回' }}
				</div>
				<div class="pad-36">
					<div class="flex-1 jus-bet mb-55">
						<div class="flex-1 w-25" v-if="details.status==3000">
							<p class="tiantou font-1">驳回原因:</p>
							<p class="names font-1">{{details.reason}}</p>
						</div>
						<div class="flex-1 w-25">
							<p class="tiantou font-1">申请时间:</p>
							<p class="names font-1" :title="utils.getNowTime(details.createTime)">
								{{utils.getNowTime(details.createTime)}}
							</p>
						</div>
						<div class="flex-1 w-25">
							<p class="tiantou font-1">发票类型:</p>
							<p class="names font-1">{{details.invoiceType}}</p>
						</div>
					</div>
					<div class="flex-1 jus-bet mb-55">
						<div class="flex-1 w-25">
							<p class="tiantou font-1">抬头类型:</p>
							<p class="names font-1">{{details.headingType==1?'个人':'企业'}}</p>
						</div>
						<div class="flex-1 w-25">
							<p class="tiantou font-1">发票抬头:</p>
							<p class="names font-1">{{details.invoiceHeading}}</p>
						</div>
						<div class="flex-1 w-25" v-if="details.headingType == 2">
							<p class="tiantou font-1">企业税号:</p>
							<p class="names font-1">{{details.enterpriseTaxNo}}</p>
						</div>
					</div>
					<div class="flex-1 jus-bet mb-55">
						<div class="flex-1 w-25" v-if="details.headingType == 2">
							<p class="tiantou font-1">企业地址:</p>
							<p class="names font-1">{{details.enterpriseAddress}}</p>
						</div>
						<div class="flex-1 w-25" v-if="details.headingType == 2">
							<p class="tiantou font-1">企业电话:</p>
							<p class="names font-1">{{details.enterpriseMobile}}</p>
						</div>
						<div class="flex-1 w-25" v-if="details.headingType == 2">
							<p class="tiantou font-1">开户银行:</p>
							<p class="names font-1">{{details.bankName}}</p>
						</div>
					</div>
					<div class="flex-1 jus-bet mb-55">
						<div class="flex-1 w-25" v-if="details.headingType == 2">
							<p class="tiantou font-1">开户账号:</p>
							<p class="names font-1">{{details.accountOpen}}</p>
						</div>
						<div class="flex-1 w-25">
							<p class="tiantou font-1">手机号码:</p>
							<p class="names font-1">{{details.mobile}}</p>
						</div>
						<div class="flex-1 w-25">
							<p class="tiantou font-1">电子邮箱:</p>
							<p class="names font-1">{{details.email}}</p>
						</div>
					</div>
					<div class="flex-1 jus-bet ">
						<div class="flex-1 w-25">
							<p class="tiantou font-1">邮寄地址:</p>
							<p class="names font-1" :title="details.mailAddress">{{details.mailAddress}}</p>
						</div>
						<div class="flex-1 w-25">
							<p class="tiantou font-1">开票金额:</p>
							<p class="names font-1">{{details.amount}}元</p>
						</div>
					</div>
				</div>

			</div>
			<div class="flex-1 jus-bet" v-if="details.status==3000">
				<div></div>
				<el-button type="primary" @click="apply">重新申请</el-button>
				<div></div>
			</div>
			<div class="box-shadow pad-16" v-if="details.status==2000">
				<div class="flex-1">
					<div class="left-icon"></div>
					<p class="experts">我的发票</p>
				</div>
				<img :src="details.invoiceUrl" alt="" class="fapiao">
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		getInvoiceDetail,
		getApply
	} from '@/api/personal/api.js';
	export default {
		components: {},
		data() {
			return {
				voiceList: [{
						status: '0',
					},
					{
						status: '1',
					},
					{
						status: '2',
					}
				],
				status: '',
				details: ''
			}

		},
		created() {},
		mounted() {
			// console.log(this.$route.params.id,'cecece')
			this.getDetail(this.$route.params.id);
			this.status = this.$route.params.status;
		},
		methods: {
			getDetail(id) {
				getInvoiceDetail({
						id: id
					}).then(res => {
						console.log(res, '==')
						this.details = res.data;
					})
					.catch(error => {

					});
			},
			relate(id) {
				// this.$router.push('/personal/service/invoice/relatedOrders')
				this.$router.push({
					name: '/invoice/relatedOrders',
					params: {
						id: id
					}
				})
			},
			apply() {
				this.$router.push({
					name: '/invoice/inInformation',
					params: {
						levelOrderIds: this.details.levelOrderIds,
						activityOrderIds: this.details.activityOrderIds,
						amount: this.details.amount,
					}
				})
				// this.details.status = 1000;
				// let params = this.details;
				// getApply(params).then(res => {
				// 		if (res.code == 0) {
				// 			this.$message.success('提交成功');
				// 			// 跳转我的发票
				// 			this.$router.push('/personal/service/invoice/myInvoice')
				// 		}
				// 	})
				// 	.catch(error => {

				// 	});
			}
			// details() {

			// }
		}
	}
</script>

<style>

</style>
<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-36 {
		padding: 36px 16px 51px 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.status {

		border-radius: 8px 8px 0 0;
		padding: 6px 0 5px 16px;
	}

	.status span {
		padding-right: 16px;
	}

	.tiantou {
		color: #999999;
		padding-right: 16px;
	}

	.money {
		color: #FFBA31;
	}

	.font-1 {
		font-size: 14px;
		font-family: font3;
		line-height: 21px;
	}

	.names {
		color: #222222;
	}

	.details {
		color: #333333;
		padding-right: 8px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.col-1 {
		color: #3ECC64;
		background-color: #EBFAEF;
	}

	.col-2 {
		color: #FF534D;
		background-color: #FFF0F0;
	}

	.col-3 {
		color: #FBB54C;
		background-color: #FFF6F0;
	}

	.pad-16 {
		padding: 16px;
	}

	.experts {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		padding-left: 10px;
	}

	.money-1 {
		font-family: font5;
	}

	.c-iocn {
		color: #999999;
		font-size: 14px;
		font-weight: 800;
	}

	.mb-55 {
		margin-bottom: 55px;
	}

	.w-25 {
		width: 32%;
		white-space: nowrap;
	}

	.w-25 .names {
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.el-button--primary {
		background-color: #3377FF;
		color: #ffffff;
		font-family: font3;
		border-radius: 4px;
		margin-top: 40px;
		width: 15%;
		text-align: center;
	}

	.el-button--primary span {
		/* font-size: 16px; */
	}

	.fapiao {
		width: 321px;
		height: 174px;
		margin-top: 24px;
	}
</style>